import * as React from 'react';
import * as styles from './AuctionBetInput.css';
import { TextField } from '@cian/text-field-component';
import { Tooltip, TooltipPosition } from '@cian/tooltip-component';
import { keepValueInRange, getNearestUpperMultiple } from '@cian/utils';
import * as PropTypes from 'prop-types';
import { auctionBetValidator, TAuctionBetValidatorResult } from '../../../utils/auctionBetValidator';

export interface IAuctionBetInputProps {
  initialBet: number;
  stepBet: number;
  validateStep: boolean;
  disabled?: boolean;
  trackChangeBetClick?(): void;
  onChange(v: number, i: boolean): void;
  auctionBetCalculator(value: number | null): number;
}

export interface IAuctionBetInputState {
  bet: number;
  isBetValid: boolean;
  betErrorText?: TAuctionBetValidatorResult;
}

export class AuctionBetInput extends React.Component<IAuctionBetInputProps, IAuctionBetInputState> {
  public static contextTypes = {
    auctionMinBet: PropTypes.number,
    auctionMaxBet: PropTypes.number,
  };

  public constructor(props: IAuctionBetInputProps) {
    super(props);

    this.state = {
      bet: props.initialBet,
      isBetValid: true,
    };
  }

  public render() {
    const { auctionMaxBet } = this.context;
    const { disabled, trackChangeBetClick, auctionBetCalculator } = this.props;
    const { bet, isBetValid, betErrorText } = this.state;

    const maxBetLength = String(auctionBetCalculator(auctionMaxBet)).length;

    return (
      <div className={styles['input_wrapper']}>
        <Tooltip
          tooltipContent={betErrorText ? betErrorText.message : ''}
          position={TooltipPosition.TOP_RIGHT}
          tooltipStyles={styles['tooltip_wrapper']}
        >
          {/* NumberField версии 1.0.2 не подойдёт из-за несовместимости react-ref */}
          <TextField
            onValueChange={this.handleBetChange}
            value={String(bet)}
            maxLength={maxBetLength}
            containerStyle={styles['input_container']}
            inputStyle={styles['input']}
            invalid={!isBetValid}
            disabled={disabled}
            onBlur={trackChangeBetClick}
          />
        </Tooltip>

        <div
          className={styles['bet_increment']}
          onClick={this.handleIncreaseBet}
        >
          +
        </div>
      </div>
    );
  }

  private handleIncreaseBet = () => {
    const { trackChangeBetClick, stepBet, validateStep, auctionBetCalculator } = this.props;
    const { auctionMaxBet } = this.context;
    const { bet } = this.state;

    const newBet = validateStep
      ? getNearestUpperMultiple(bet + 1, stepBet) || 0
      : bet + 1;

    this.handleBetChange(
      keepValueInRange(
        newBet,
        0,
        auctionBetCalculator(auctionMaxBet),
      ),
    );

    if (trackChangeBetClick) {
      trackChangeBetClick();
    }
  }

  private handleBetChange = (value: string | number = 0) => {
    if (this.props.disabled) {
      return;
    }

    let bet = typeof value === 'string' ? this.processBetValue(value) : value;

    const { auctionMinBet, auctionMaxBet } = this.context;
    const { stepBet, validateStep, auctionBetCalculator } = this.props;

    const betErrorText = auctionBetValidator(
      bet,
      auctionMinBet,
      auctionBetCalculator(auctionMaxBet),
      stepBet,
      { isZeroValid: true, validateStep },
    );
    const isBetValid = !betErrorText;

    this.setState({ bet, isBetValid, betErrorText });

    this.props.onChange(bet, isBetValid);
  }

  private processBetValue = (value: string): number => {
    const normalizedValue = value.replace(/\D+/ig, '');

    return Number(normalizedValue);
  }
}
